import { getTimeText } from '@/utils/event.js';
import { IonDatetime } from '@ionic/react';
import { Popover, PopoverTrigger, Button, PopoverContent } from '@heroui/react';
import { memo } from 'react';
import isEqual from 'react-fast-compare';

const TimePicker = memo(
  ({
    startTime,
    endTime,
    onStartTimeChange,
    onEndTimeChange,
  }: {
    startTime: string;
    endTime: string;
    onStartTimeChange: (payload: string) => void;
    onEndTimeChange: (payload: string) => void;
  }) => {
    return (
      <Popover>
        <PopoverTrigger>
          <Button
            variant='bordered'
            radius='full'
            size='sm'
            className='border-1 border-gray-200 font-[500] text-gray-600 h-7'
            startContent={
              <i className='ic-outline md-access_time scale-105 -mr-1 opacity-60' />
            }
          >
            {getTimeText({ startTime, endTime }) || '添加时间'}
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <div
            className='  w-80 -mx-2.5 -my-1 rounded-2xl '
            style={{
              backgroundColor: 'rgb(244, 245, 248)',
            }}
          >
            <b className='text-xl block px-4 py-3'>设置时间</b>

            <div className='flex items-center justify-between'>
              <IonDatetime
                presentation='time'
                class='h-full w-40'
                style={{
                  backgroundColor: 'rgb(244, 245, 248)',
                }}
                onIonChange={(e) => {
                  onStartTimeChange(e.target.value as string);
                }}
                value={startTime || '00:00'}
              />
              <span className='flex-grow mx-2'>至</span>
              <IonDatetime
                presentation='time'
                class='h-full w-40'
                style={{
                  backgroundColor: 'rgb(244, 245, 248)',
                }}
                value={endTime || '00:00'}
                onIonChange={(e) => {
                  onEndTimeChange(e.target.value as string);
                }}
              />
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );
  },
  isEqual
);

export default TimePicker;
